<template>
    <div class="container">
    <div slot="body">
        <router-view></router-view>
    </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
